import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './InvoiceCreate.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Breadcrumbs, Link, Typography, TextField, MenuItem } from '@material-ui/core';
import { defaultPageSize, EDIT, roleStr } from '../../common/common'
import { getObjByName } from '../../common/utils'
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'
import CaseAutoComplete from '../Components/CaseAutoComplete';

class InvoiceCreate extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            invoiceId: "",
            matter_id: "",
            date: this.getNowDate(),
            caseObj: null,
            mattersData: [],

            alertContent: "",
            invoiceType: 0,//0:normal 1:advance
            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,
        }
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleCreateNormal = this.handleCreateNormal.bind(this);
        this.handleCreateAdvance = this.handleCreateAdvance.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.updateCaseObj = this.updateCaseObj.bind(this);
    }
    render() {
        const {
            date,
            matter_id,
            caseObj,
            mattersData,
            alertContent,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;
        const matterView = () => {
            if (mattersData) {
                if (mattersData.length > 0) {
                    return <div className="textWapper1 h h-c">
                        <div className="textTitle">Matter</div>
                        <TextField
                            margin="dense"
                            variant="outlined"
                            className="textField w600"
                            placeholder="Seach matter by matter number / matter name"
                            value={matter_id}
                            select
                            onChange={e => this.handleChange(e, 'matter_id')}
                            style={{ marginTop: 0 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {mattersData.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.number} / {option.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                }
            }
        }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/invoicelist">All Invoice</Link>
                            <Typography className="crtTitle">CREATE INVOICE</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="invoiceWapper">
                    <div className="pageTitle">NEW INVOICE</div>
                    <div className="line"></div>
                    <div className="infoBody c">
                        <div className=" v v-l">
                            <div className="textWapper1 h h-c">
                                <div className="textTitle">&nbsp;&nbsp;Case</div>
                                <div className="textField w600">
                                    <CaseAutoComplete
                                        initCase={caseObj}
                                        update={this.updateCaseObj}
                                    />
                                </div>
                            </div>
                            {matterView()}
                            <div className="textWapper2 h h-c">
                                <div className="textTitle">Date</div>
                                <TextField
                                    id="date"
                                    type="date"
                                    variant="outlined"
                                    className="dateField"
                                    margin="dense"
                                    value={date}
                                    onChange={e => this.handleChange(e, 'date')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="foot h h-c">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleCreateNormal}>create normal invoice</Button>
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleCreateAdvance}>create Advance Invoice</Button>
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    widthSize="md"
                    content={alertContent}
                    // content="Do you want to continue to edit the detailed invoice?"
                    yesLabel="NO, I’LL EDIT LATER"
                    noLabel="YES, I’D LIKE TO EDIT NOW"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
    }
    handleCreateNormal() {
        if (!this.state.matter_id) {
            this.showToast("There are no matters under this case, please add one.", "warning");
            return;
        }
        this.setState({
            invoiceType: "normal",
            alertContent: "Do you want to continue to edit the detailed invoice?",
        }, () => {
            this.createInvoice();
        })
    }
    handleCreateAdvance() {
        if (!this.state.matter_id) {
            this.showToast("Please select a matter", "warning");
            return;
        }
        this.setState({
            invoiceType: "advance",
            alertContent: "Do you want to continue to edit the detailed advance invoice?",
        }, () => {
            this.createInvoice();
        })
    }
    createInvoice() {
        const { matter_id, date, invoiceType } = this.state;
        const params = {
            invoice_type: invoiceType,
            matter_id,
            date: (Date.parse(new Date(date)) / 1000) + "",
        }
        this.addInvoice(params, (invoiceId) => {
            this.setState(() => ({
                showAlert: true,
                invoiceId,
            }));
        });
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    updateCaseObj(caseObj) {
        if (caseObj) {
            const mattersData = caseObj.matters;
            this.setState(() => ({
                caseObj,
                mattersData,
                matter_id: ""
            }))
        }
    }
    handleCancel() {
        this.closeDialog();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        this.setState(() => ({
            showAlert: false,
        }));
        this.toInvoiceInfo();
    }
    handleAlertNo() {
        const { invoiceType } = this.state;
        this.setState(() => ({
            showAlert: false,
        }));
        if (invoiceType === "normal") {
            this.props.history.push({ pathname: '/main/invoicelist' });
        } else if (invoiceType === "advance") {
            this.props.history.push({ pathname: '/main/invoicealist' });
        }
    }
    toInvoiceInfo() {
        const { invoiceId, invoiceType } = this.state;
        this.getInvoices((invoiceData) => {
            const invoiceObj = getObjByName(invoiceData, "id", invoiceId)
            console.log(invoiceData, invoiceObj)
            localStorage.setItem('invoiceObj', JSON.stringify(invoiceObj));
            localStorage.setItem('invoiceState', EDIT);
            if (invoiceType === "normal") {
                this.props.history.push({ pathname: '/main/invoicenormalinfo' });
            } else if (invoiceType === "advance") {
                this.props.history.push({ pathname: '/main/invoiceadvanceinfo' });
            }
        });
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            crtMatterObj: null,
        }));
    }
    getNowDate() {
        let date = new Date();
        let dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split("T")[0];
        return dateString;
    }
    //-----------request-------------
    addInvoiceAdvance(params, callback) {
        instance.post(BASE_URL + roleStr() + '/billing/invoices', params).then((res) => {
            const invoiceId = res.data.data.id;
            console.log(invoiceId)
            // this.showToast("Added successfully", "success");
            callback(invoiceId);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addInvoice(params, callback) {
        instance.post(BASE_URL + roleStr() + '/billing/invoices', params).then((res) => {
            const invoiceId = res.data.data.id;
            console.log(invoiceId)
            // this.showToast("Added successfully", "success");
            callback(invoiceId);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    getInvoices(callback) {
        const { invoiceType } = this.state;
        let type = invoiceType === "advance" ? "advance" : "";
        let params = {
            type,
            page_index: 1,
            page_size: defaultPageSize
        }
        instance.get(BASE_URL + roleStr() + '/billing/invoices', { params }).then((res) => {
            const invoiceData = res.data.data;
            callback(invoiceData);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(InvoiceCreate);